



























































































































































import Vue from 'vue';
import VueCompositionAPI, {defineComponent, PropType} from '@vue/composition-api';
import {
  AmexFilter,
  AmexButton,
  // AmexDestinationGroup,
  SearchInput,
  AmexDropdown,
  InterestDropItem,
  Tag,
  TagExt,
  AmexSearchInput,
  AmexDropItem,
} from '@mobi-components/amex-bluesky-components';
import {commonExploreView, ExploreArgs} from './common-explore-view';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import SectionsHeader from './sections-header.vue';
import {ToggleComponent} from '@mobi-components/toggle';
import '@mobi-components/amex-poi-details-view/dist/amex-poi-details-view.css';
import ExpItem from '../../explore-page/exp-list/exp-item.vue';
import PoweredByMobiFooter from '@common/powered-by-mobi-footer.vue';
import PlaceWithSchedule from '../explore-view/place-with-schedule.vue';
import AmexDestinationGroup from '@components/old-home-page/destination-details/dest-group.vue';

Vue.use(VueCompositionAPI);

const AmexDiningDetails = defineComponent({
  components: {
    ExpItem,
    AmexFilter,
    AmexButton,
    AmexDestinationGroup,
    SectionsHeader,
    AmexDropdown,
    SearchInput,
    InterestDropItem,
    Tag,
    ToggleComponent,
    TagExt,
    AmexSearchInput,
    AmexDropItem,
    PoweredByMobiFooter,
    PlaceWithSchedule,
  },
  props: {
    selectedDay: {
      type: Number,
      default: 0,
    },
    category: {
      type: String as PropType<UserActivityCategoryEnum>,
      required: true,
    },
    isSplashVisible: {
      type: Boolean,
      default: false,
    },
    isFiltersAvailable: {
      type: Boolean,
      default: true,
    },
    isDeprecated: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, v) {
    return {
      ...commonExploreView(props, (v as unknown) as ExploreArgs),
      isFooterAvailable: process.env.VUE_APP_IS_FOOTER_VISIBLE || false,
    };
  },
});

export default AmexDiningDetails;
